import { useEffect } from "react"
const HeroSection = () => {
    useEffect(() => {
        const video = document.getElementById('main-video')
        if (video) {
            video.addEventListener('ended', () => {
                video.currentTime = 2;
                video.play()
            })
        }
    }, [])


    return (
        <div className='ratio ratio-5x2' >
            <video id="main-video" autoPlay muted>
                <source src="/video/hero_video.mp4" type="video/mp4" />
            </video>
        </div>
    )
}

export default HeroSection